import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatMoney } from "@/lib/api";

export default function MyProfile() {
  const [emp, setEmp] = useState(null);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/me/profile"); setEmp(data); } catch {}
    })();
  }, []);

  if (!emp) return <div className="text-sm text-zinc-500">Loading…</div>;

  return (
    <div className="space-y-6" data-testid="me-profile">
      <div>
        <div className="font-mono text-[10px] tracking-widest uppercase text-zinc-500 mb-2">My space</div>
        <h1 className="font-heading text-4xl font-black tracking-tight">Profile</h1>
      </div>
      <div className="bg-white border border-zinc-200 rounded-sm">
        <div className="p-6 flex items-center gap-4 border-b border-zinc-200">
          <div className="h-16 w-16 rounded-sm grid place-items-center bg-[#09090B] text-white font-heading font-black text-2xl">
            {emp.full_name?.slice(0, 1).toUpperCase()}
          </div>
          <div>
            <div className="font-heading text-2xl font-black tracking-tight">{emp.full_name}</div>
            <div className="text-sm text-zinc-500">{emp.designation} · {emp.department}</div>
            <div className="font-mono text-xs text-zinc-500 mt-1">{emp.employee_code}</div>
          </div>
        </div>
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <Row label="Email" value={emp.email} />
          <Row label="Phone" value={emp.phone || "—"} />
          <Row label="Employee type" value={emp.employee_type} />
          <Row label="Join date" value={emp.join_date} mono />
          <Row label="Status" value={emp.status} />
          <Row label="Monthly salary" value={formatMoney(emp.salary, "INR")} mono />
        </div>
      </div>
    </div>
  );
}

function Row({ label, value, mono }) {
  return (
    <div>
      <div className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mb-1">{label}</div>
      <div className={`text-sm ${mono ? "font-mono" : ""}`}>{value}</div>
    </div>
  );
}
